import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../common/Button';

export const CTA: React.FC = () => {
  const navigate = useNavigate();
  
  return (
    <section className="relative py-24 bg-brand-blue overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-96 h-96 bg-brand-red rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-brand-red rounded-full blur-3xl" />
      </div>
      
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
          Ready to Transform Your Appeal Process?
        </h2>
        
        <p className="text-xl text-brand-blue-100 mb-10">
          Join hundreds of tax professionals who are winning more appeals 
          with Appeal Advantage.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button size="lg" onClick={() => navigate('/contact')}>
            Request a Demo
          </Button>
          <Button variant="outline" size="lg" onClick={() => navigate('/contact')}>
            Contact Sales
          </Button>
        </div>
        
        <p className="text-sm text-brand-blue-100 mt-8">
          No credit card required • Free 14-day trial • Setup in minutes
        </p>
      </div>
    </section>
  );
};

